module.exports = "https://static.wmbcdn.com/uniweb/images/fd44a7e00a10ead508b7e36130b9d9a6.jpg";